module.exports = __webpack_public_path__ + "static/media/screenshot-7.315ee8e4.png";